module.exports = __webpack_public_path__ + "static/media/grid.ac7d31bb.svg";